import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    Typography, Tooltip,
} from '@material-ui/core';
import { modules } from 'utils/enum/modules';
import { makeStyles } from '@material-ui/core/styles';
import If from 'components/widgets/conditional/If';
import LeadWidget from 'components/modules/messageCenter/read/LeadWidget';
import DealWidget from 'components/modules/messageCenter/read/DealWidget';
import MessageCenterLayoutStyle from 'styles/modules/crm/MessageCenterLayoutStyle';
import OpportunityWidget from 'components/modules/messageCenter/read/OpportunityWidget';

const useStyles = makeStyles((theme) => MessageCenterLayoutStyle.content(theme));
const CustomerSection = ({
    customer,
}) => {
    const classes = useStyles();

    let name = 'Unknown';
    let email = null;
    if (customer?.customerId != null) {
        name = `${customer.firstName || ''} ${customer.lastName || ''}`.trim();
        email = customer.email;
    }

    return (
        <div className={clsx(classes.opportunityContainer, classes.leftSection)}>
            <div className={classes.customerInformation}>
                <div>
                    <Typography variant="h4" className={classes.customer} title={name} noWrap>{name}</Typography>
                    <If condition={email !== null}>
                        <div>
                            <span className={classes.label}>Email: </span>
                            <span className={classes.value}>{email}</span>
                        </div>
                    </If>
                </div>
                <Tooltip title="Open Opportunity" placement="top">
                    <div>
                        <a href={`/${modules.OPPORTUNITIES}/${customer.opportunity.crmId}`} target="_blank" rel="noopener noreferrer">
                            {customer.opportunity.leadCode}
                        </a>
                    </div>
                </Tooltip>
            </div>
            <LeadWidget
                customerId={customer.customerId}
            />
            <OpportunityWidget
                customerId={customer.customerId}
            />
            <DealWidget
                customerId={customer.customerId}
            />
        </div>
    );
};

CustomerSection.propTypes = {
    customer: PropTypes.object.isRequired,
};

export default CustomerSection;
